//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.PackagingBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"ActionType",1,0],[1,"ClearanceExpression",0,"Expression",0],[0,"FrameType",1,0],[0,"ModeType",1,0],[0,"StopOnEvent",1,0]],[[["num_list2"],"GetList2",{R_:{list2:"DisplayableObject[]"}},0,0],[["list2"],"SetList2",{},1,0],[["num_links"],"GetRelativeLinks",{R_:{links:"DisplayableObject[]"}},0,0],[["links"],"SetRelativeLinks",{},1,0]],[]];
SPLM.Motion.PackagingInterferenceBuilder = class extends SPLM.Motion.PackagingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.PackagingInterferenceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.PackagingInterferenceBuilder.Action = Object.freeze({
    "Highlight" : "Highlight", "CreateSolids" : "CreateSolids", "ShowIntersectionCurve" : "ShowIntersectionCurve"});

SPLM.Motion.PackagingInterferenceBuilder.Mode = Object.freeze({
    "Faceted" : "Faceted", "PreciseSolid" : "PreciseSolid"});

SPLM.Motion.PackagingInterferenceBuilder.Frame = Object.freeze({
    "Absolute" : "Absolute", "FirstSet" : "FirstSet", "SecondSet" : "SecondSet", "BothSets" : "BothSets", "Selected" : "Selected"});

export default SPLM;